import { Swiper } from '@services';
import { N as Navigation } from './navigation-Bm_wcxKy.js';
import './create-element-if-not-defined-CdtEf1Zs.js';
import './utils-BgX2tuHA.js';

class ShopTheLook extends HTMLElement {
  swiperContainer = this.querySelector('.swiper');
  nextButton = this.querySelector('.swiper-button-next');
  prevButton = this.querySelector('.swiper-button-prev');

  connectedCallback() {
    if (!this.swiperContainer) return;

    this.initSwiper();
  }

  /**
   * Initializes the swiper instance
   */
  initSwiper() {
    this.swiperInstance = new Swiper(this.swiperContainer, {
      modules: [Navigation],
      slidesPerView: 1.25,
      spaceBetween: 1,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
      loop: true,
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton,
      },
      breakpoints: {
        768: {
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          slidesPerView: 1.75,
        },
        1024: {
          slidesPerView: 1.25,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        },
      },
    });
  }
}

customElements.define('shop-the-look', ShopTheLook);
